//{% # Intact Web wishlist %}
let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

function updateWishlistButtons() {
  document.querySelectorAll(".wishlist-btn").forEach(btn => {
    const handle = btn.dataset.handle;
    if (wishlist.includes(handle)) {
      btn.classList.add("active");
      btn.setAttribute("aria-label", "Remove from wishlist");
    } else {
      btn.classList.remove("active");
      btn.setAttribute("aria-label", "Add to wishlist");
    }
  });
}

function updateCounters() {
  const desktopCounter = document.getElementById("wishlist-count-desktop");
  if (desktopCounter) {
    desktopCounter.innerText = wishlist.length;
    desktopCounter.style.display = wishlist.length ? "inline-block" : "none";
  }

  const mobileCounter = document.getElementById("wishlist-count-mobile");
  if (mobileCounter) {
    mobileCounter.innerText = wishlist.length;
    mobileCounter.style.display = wishlist.length ? "inline-block" : "none";
  }
}

function showToast(message) {
  let toast = document.getElementById("wishlist-toast");
  if (!toast) {
    toast = document.createElement("div");
    toast.id = "wishlist-toast";
    toast.style.position = "fixed";
    toast.style.bottom = "20px";
    toast.style.right = "20px";
    toast.style.background = "#333";
    toast.style.color = "#fff";
    toast.style.padding = "10px 15px";
    toast.style.borderRadius = "4px";
    toast.style.opacity = "0";
    toast.style.transition = "opacity 0.3s ease";
    toast.style.zIndex = "9999";
    toast.style.fontSize = "14px";
    document.body.appendChild(toast);
  }

  toast.innerText = message;
  toast.style.opacity = 1;

  setTimeout(() => {
    toast.style.opacity = 0;
  }, 2000);
}

document.addEventListener("click", e => {
  const btn = e.target.closest(".wishlist-btn");
  if (!btn) return;

  const handle = btn.dataset.handle;

  if (wishlist.includes(handle)) {
    wishlist = wishlist.filter(h => h !== handle);
    showToast("Removed from Wishlist ❤️");
  } else {
    wishlist.push(handle);
    showToast("Added to Wishlist ❤️");
  }

  localStorage.setItem("wishlist", JSON.stringify(wishlist));

  updateWishlistButtons();
  updateCounters();
});

document.addEventListener("DOMContentLoaded", () => {
  updateWishlistButtons();
  updateCounters();
});
